import React from "react";
import PropertyCard from "./PropertyCard";
import { usePropertyStore } from "../../../stores/PropertyStore";
import NearYouSection from "./NearYouSection";

function PropertiesPage() {
  const getProperties = usePropertyStore((state) => state.properties);
    const pageLimit = 4;
    const [currentPage, setCurrentPage] = React.useState(0);
    const [properties, setProperties] = React.useState([]);
    const pages = () => {
        var count = Math.ceil(getProperties.length / pageLimit);
        var arr=[];
        for(var i = 0; i<count; i++){
            arr.push(i);
        }
        return arr;
    }
    
    React.useEffect(() => {
        setProperties(getProperties.slice(currentPage*pageLimit,currentPage*pageLimit+ pageLimit));
    }
        , [currentPage, getProperties]);
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
    }




  return (
    <>
      <section className="flat-title-page inner style">
        <div className="overlay2" />
      </section>
      <section className="flat-title">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner style">
                <div className="title-group fs-12">
                  <a className="home fw-6 text-color-3" href="/">
                    Accueil
                  </a>
                  <span>Liste des biens</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-featured flat-property flat-property-grid-2 tf-section2 wg-dream style">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="post">
                <div className="category-filter flex justify-space">
                  <div className="box-1 ">
                    <div className="heading-listing fs-30 lh-45 fw-7">
                      Liste des biens
                    </div>
                    <div className="">
                      {getProperties.length} propriétés enregistrées
                    </div>
                  </div>
                </div>
                <div className="wrap-item form-wg flex flex-wrap">
                  {properties.map((p) => {
                    return <PropertyCard key={p.id} property={p} />;
                  })}
                </div>
                <div className="themesflat-pagination clearfix style2 center">
                  <ul>
                    <li>
                      <a href="#" className="page-numbers style">
                        <i className="far fa-angle-left" />
                      </a>
                    </li>
                    {pages().map((p, i) => (
                      <li>
                        <a
                          onClick={() => {
                            handlePageChange(i);
                          }}
                          className={
                            "page-numbers" +
                            (i === currentPage ? " current" : "")
                          }
                        >
                          {i + 1}
                        </a>
                      </li>
                    ))}

                    <li>
                      <a href="#" className="page-numbers style">
                        <i className="far fa-angle-right" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="side-bar">
                <div className="inner-side-bar">
                  <div className="widget-rent">
                    <div className="flat-tabs style2">
                      <div className="content-tab">
                        <div className="content-inner tab-content">
                          <div className="form-s2">
                            <form method="post">
                              <div className="wd-find-select ">
                                <div className="form-group-1 search-form form-style2 relative">
                                  <i className="far fa-search" />
                                  <input
                                    type="search"
                                    className="search-field"
                                    placeholder="Tapez un mot-clé..."
                                    defaultValue=""
                                    name="s"
                                    title="Rechercher"
                                    required=""
                                  />
                                </div>
                                <div className="form-group-2 form-style2">
                                  <div className="group-select">
                                    <div className="nice-select" tabIndex={0}>
                                      <span className="current">
                                        Type de propriété
                                      </span>
                                      <ul className="list style">
                                        <li
                                          data-value=""
                                          className="option selected"
                                        >
                                          Choisir
                                        </li>
                                        <li
                                          data-value="apartment"
                                          className="option"
                                        >
                                          Appartement
                                        </li>
                                        <li
                                          data-value="house"
                                          className="option"
                                        >
                                          Maison
                                        </li>
                                        <li
                                          data-value="rent"
                                          className="option"
                                        >
                                          Location
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-group-3 form-style2">
                                  <div className="group-select">
                                    <div className="nice-select" tabIndex={0}>
                                      <span className="current">
                                        Emplacement
                                      </span>
                                      <ul className="list">
                                        <li
                                          data-value=""
                                          className="option selected"
                                        >
                                          Emplacement
                                        </li>
                                        <li
                                          data-value="Japan"
                                          className="option"
                                        >
                                          Japon
                                        </li>
                                        <li
                                          data-value="America"
                                          className="option d"
                                        >
                                          Amérique
                                        </li>
                                        <li
                                          data-value="England"
                                          className="option"
                                        >
                                          Angleterre
                                        </li>
                                        <li
                                          data-value="Japan"
                                          className="option"
                                        >
                                          Belgique
                                        </li>
                                        <li
                                          data-value="England"
                                          className="option"
                                        >
                                          France
                                        </li>
                                        <li
                                          data-value="VietNam"
                                          className="option"
                                        >
                                          Vietnam
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-group-4 form-style2">
                                  <div className="group-select">
                                    <div className="nice-select" tabIndex={0}>
                                      <span className="current">Bains</span>
                                      <ul className="list">
                                        <li
                                          data-value=""
                                          className="option selected"
                                        >
                                          Bains
                                        </li>
                                        <li
                                          data-value="floating"
                                          className="option"
                                        >
                                          Bains flottants
                                        </li>
                                        <li
                                          data-value="massage"
                                          className="option"
                                        >
                                          Bains massage
                                        </li>
                                        <li
                                          data-value="floor-standing"
                                          className="option"
                                        >
                                          Bain sur pied
                                        </li>
                                        <li
                                          data-value="built-in"
                                          className="option"
                                        >
                                          Bains encastrés
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-group-5 form-style2">
                                  <div className="group-select">
                                    <div className="nice-select" tabIndex={0}>
                                      <span className="current">Lits</span>
                                      <ul className="list">
                                        <li
                                          data-value=""
                                          className="option selected"
                                        >
                                          Lits
                                        </li>
                                        <li
                                          data-value="twin"
                                          className="option"
                                        >
                                          Lits jumeaux
                                        </li>
                                        <li
                                          data-value="bunk"
                                          className="option"
                                        >
                                          Lits superposés
                                        </li>
                                        <li
                                          data-value="kids"
                                          className="option"
                                        >
                                          Lits pour enfants
                                        </li>
                                        <li
                                          data-value="single"
                                          className="option"
                                        >
                                          Lit simple
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="price-group style-group">
                                  <h4>Prix</h4>
                                  <div className="inner flex flex-wrap">
                                    <div className="group-select">
                                      <div className="nice-select" tabIndex={0}>
                                        <span className="current">Min</span>
                                        <ul className="list">
                                          <li
                                            data-value=""
                                            className="option selected"
                                          >
                                            Min
                                          </li>
                                          <li data-value={0} className="option">
                                            0
                                          </li>
                                          <li
                                            data-value={100}
                                            className="option"
                                          >
                                            $100
                                          </li>
                                          <li
                                            data-value={300}
                                            className="option"
                                          >
                                            $300
                                          </li>
                                          <li
                                            data-value={500}
                                            className="option"
                                          >
                                            $500
                                          </li>
                                          <li
                                            data-value={700}
                                            className="option"
                                          >
                                            $700
                                          </li>
                                          <li
                                            data-value={1000}
                                            className="option"
                                          >
                                            $1,000
                                          </li>
                                          <li
                                            data-value={1300}
                                            className="option"
                                          >
                                            $1,300
                                          </li>
                                          <li
                                            data-value={1500}
                                            className="option"
                                          >
                                            $1,500
                                          </li>
                                          <li
                                            data-value={1700}
                                            className="option"
                                          >
                                            $1,700
                                          </li>
                                          <li
                                            data-value={2000}
                                            className="option"
                                          >
                                            $2,000
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div className="group-select">
                                      <div className="nice-select" tabIndex={0}>
                                        <span className="current">Max</span>
                                        <ul className="list">
                                          <li
                                            data-value=""
                                            className="option selected"
                                          >
                                            Max
                                          </li>
                                          <li
                                            data-value={200}
                                            className="option"
                                          >
                                            $200
                                          </li>
                                          <li
                                            data-value={400}
                                            className="option"
                                          >
                                            $400
                                          </li>
                                          <li
                                            data-value={600}
                                            className="option"
                                          >
                                            $600
                                          </li>
                                          <li
                                            data-value={800}
                                            className="option"
                                          >
                                            $800
                                          </li>
                                          <li
                                            data-value={1100}
                                            className="option"
                                          >
                                            $1,100
                                          </li>
                                          <li
                                            data-value={1400}
                                            className="option"
                                          >
                                            $1,400
                                          </li>
                                          <li
                                            data-value={1600}
                                            className="option"
                                          >
                                            $1,600
                                          </li>
                                          <li
                                            data-value={1800}
                                            className="option"
                                          >
                                            $1,800
                                          </li>
                                          <li
                                            data-value={2200}
                                            className="option"
                                          >
                                            $2,200
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="button-search sc-btn-top center">
                                  <a className="sc-button" href="#">
                                    <span>Rechercher maintenant</span>
                                    <i className="far fa-search text-color-1" />
                                  </a>
                                </div>
                              </div>
                            </form>
                            {/* End Job  Search Form*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <NearYouSection/>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PropertiesPage;
